import React, { useState, useEffect, useRef, useMemo } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Polyline, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css'; // use your dashboard CSS for consistency
import axios from "axios";

const API =
  process.env.REACT_APP_BACKEND || "http://localhost:5000";

// Truck icon for the map
const truckIcon = L.icon({
  iconUrl: 'https://www.citypng.com/public/uploads/preview/delivery-freight-black-truck-icon-download-png-701751695035832ecrif00wda.png',
  iconSize: [40, 40],
  iconAnchor: [20, 40],
});
const homeIcon = L.icon({
  iconUrl: 'https://cdn-icons-png.flaticon.com/512/1946/1946436.png',
  iconSize: [35, 35],
  iconAnchor: [17, 35],
});

// Auto-follow map component
function MapAutoFollow({ position }) {
  const map = useMap();
  useEffect(() => {
    map.setView(position, map.getZoom(), { animate: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [position]);
  return null;
}

export default function GPSModule() {
 const [destination, setDestination] = useState(null);
  const speedKmph = 40;
  const tankerRef = useRef({ lat: 33.6844, lng: 73.0479 });
  const targetRef = useRef(tankerRef.current);
  const [, forceUpdate] = useState(0);
  const [eta, setEta] = useState(null);
  const [arrived, setArrived] = useState(false);
  const [showRating,setShowRating]=useState(false);

const [rating,setRating]=useState(5);
const [currentOrder, setCurrentOrder] = useState(null);

const [review,setReview]=useState("");

  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState('');
  const [lastUpdated, setLastUpdated] = useState('');
  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    const currentUser = JSON.parse(localStorage.getItem('user'));
    setUserEmail(currentUser?.email || '');
  }, []);


  // =========================
// PROVIDER LIVE GPS SENDING
// =========================

// =========================
// 🚚 TANKER LIVE GPS MODE
// =========================







useEffect(() => {

  const loadDestination = async () => {

    try {

      const res = await fetch(
  `${API}/api/customer/orders/${user._id}`
);

      const orders = await res.json();


      const acceptedOrder = orders.find(
        order => order.status === "accepted"
      );


      if (!acceptedOrder) {
        setDestination(null);
        return;
      }
        setCurrentOrder(acceptedOrder);

      setDestination({
        lat: acceptedOrder.location.latitude,
        lng: acceptedOrder.location.longitude
      });


    } catch(err){
      console.log(err);
    }

  };


  if(user?._id){
    loadDestination();
  }


  const interval = setInterval(
    loadDestination,
    5000
  );


  return () => clearInterval(interval);


}, [user?._id]);
  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    sessionStorage.clear();
    navigate('/login');
  };

  // Haversine distance
  const distanceKm = (a, b) => {

  if (!a || !b) return 0;

  if (
    typeof a.lat !== "number" ||
    typeof a.lng !== "number" ||
    typeof b.lat !== "number" ||
    typeof b.lng !== "number"
  ) {
    return 0;
  }


  const R = 6371;
    const dLat = ((b.lat - a.lat) * Math.PI) / 180;
    const dLng = ((b.lng - a.lng) * Math.PI) / 180;
    const aa =
      Math.sin(dLat / 2) ** 2 +
      Math.cos((a.lat * Math.PI) / 180) *
      Math.cos((b.lat * Math.PI) / 180) *
      Math.sin(dLng / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(aa), Math.sqrt(1 - aa));
    return R * c;
  };

  // Fetch tanker target from backend every 5s
  useEffect(() => {
   const fetchTarget = async () => {

    if (!destination) return;

    const res = await fetch(
  `${API}/api/tanker-location`
);

    const data = await res.json();

    targetRef.current = data.location;

    setLastUpdated(
        new Date().toLocaleTimeString()
    );

};

    fetchTarget();
    const interval = setInterval(fetchTarget, 5000);
    return () => clearInterval(interval);
  }, [destination]);

  // Animate tanker movement
  useEffect(() => {
    let animationFrame;
    let arrivedAlertShown = false;

    const animate = () => {

  // wait until destination and tanker location exist
  if (!destination || !targetRef.current) {
    animationFrame = requestAnimationFrame(animate);
    return;
  }


  const cur = tankerRef.current;
  const target = targetRef.current;

      const latDiff = target.lat - cur.lat;
      const lngDiff = target.lng - cur.lng;

      if (Math.abs(latDiff) > 0.00001 || Math.abs(lngDiff) > 0.00001) {
        tankerRef.current = {
          lat: cur.lat + latDiff * 0.03,
          lng: cur.lng + lngDiff * 0.03,
        };
      } else {
        tankerRef.current = target;
      }

      // Update ETA
      const dist = distanceKm(tankerRef.current, destination);
      const etaMinutes = Math.max(Math.round((dist / speedKmph) * 60), 0);
      setEta(etaMinutes);

      // Arrival alert only once
      if (dist < 0.02 && !arrivedAlertShown) {
        setArrived(true);
        arrivedAlertShown = true;
        setShowRating(true);
      }

      forceUpdate(prev => prev + 1);
      animationFrame = requestAnimationFrame(animate);
    };

    animate();
    return () => cancelAnimationFrame(animationFrame);
  }, [destination]);

if (!destination) {
  return (
    <div className="dashboard-page">
      <h2 style={{ textAlign: 'center', marginTop: '40px' }}>
        Loading delivery location...
      </h2>
    </div>
  );
}

  const remainingDistance = distanceKm(
  tankerRef.current,
  destination
).toFixed(2);

const progress = Math.max(
  0,
  Math.min(100, 100 - remainingDistance * 10)
);



const submitRating = async () => {

  try {

    await axios.post(
  `${API}/api/rating/submit`,
      {
        orderId: currentOrder._id,
        providerId: currentOrder.providerId,
        customerId: currentOrder.customerId,
        rating,
        review
      }
    );

    alert("Thank you for your feedback!");

  } catch (err) {

    alert(err.response?.data?.message);

  }

};

 return (
<div className="dashboard-page">


<header className="topbar">

<div className="logo">
💧 AquaPure
</div>


<div className="profile">

<span>
Hi, {userEmail}
</span>


<button
className="logout"
onClick={handleLogout}
>
Logout
</button>


</div>

</header>





<div className="dashboard-container">


<div className="tracking-heading">

<p className="small-title">
LIVE DELIVERY SERVICE
</p>


<h1>
🚚 Track Your Water Delivery
</h1>


<p>
Follow your order in real-time and know exactly when your fresh water arrives.
</p>


</div>








<div className="stats">


<div className="stat-card">

<div className="stat-icon">
🚚
</div>


<h2>
{arrived ? "Arrived" : "On Route"}
</h2>


<p>
Delivery Status
</p>

</div>






<div className="stat-card">

<div className="stat-icon">
⏱️
</div>


<h2>
{
arrived
?
"Done"
:
eta !== null
?
`${eta} min`
:
"--"
}
</h2>


<p>
Estimated Arrival
</p>

</div>







<div className="stat-card">

<div className="stat-icon">
📍
</div>


<h2>
{remainingDistance} km
</h2>


<p>
Distance Left
</p>

</div>


</div>










<div className="dashboard-card progress-card">


<h3>
📦 Delivery Progress
</h3>


<div className="progress-container">

<div
className="progress-fill"
style={{
width:`${progress}%`
}}
>

</div>


</div>



<p>
{Math.round(progress)}% Completed
</p>



</div>









<div className="dashboard-card map-card">


<h2>
📍 Live Delivery Map
</h2>



<MapContainer

center={tankerRef.current}

zoom={14}

className="leaflet-container"

>


<TileLayer

url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"

/>



<Marker

position={tankerRef.current}

icon={truckIcon}

>

<Popup>
🚚 Delivery Vehicle
</Popup>


</Marker>




<Marker

position={destination}

icon={homeIcon}

>

<Popup>
🏠 Your Location
</Popup>

</Marker>





<Polyline

positions={[
tankerRef.current,
destination
]}

/>




<MapAutoFollow

position={tankerRef.current}

/>


</MapContainer>



</div>









<div className="tracking-grid">





<div className="dashboard-card modern-card">


<div className="card-title">

<span>
📡
</span>

<h3>
Live Information
</h3>


</div>





<div className="info-row">

<span>
🚚 Speed
</span>

<strong>
40 km/h
</strong>

</div>





<div className="info-row">

<span>
🛰 GPS
</span>

<strong className="online">
Connected
</strong>

</div>






<div className="info-row">

<span>
📍 Latitude
</span>

<strong>
{tankerRef.current.lat.toFixed(5)}
</strong>

</div>





<div className="info-row">

<span>
📍 Longitude
</span>

<strong>
{tankerRef.current.lng.toFixed(5)}
</strong>

</div>





<div className="info-row">

<span>
🕒 Last Update
</span>

<strong>
{lastUpdated || "Loading"}
</strong>

</div>



</div>









<div className="dashboard-card modern-card">


<div className="card-title">

<span>
🛡️
</span>

<h3>
Delivery Security
</h3>

</div>





<div className="status-item success">
✔ Live location tracking
</div>



<div className="status-item success">
✔ Automatic ETA updates
</div>



<div className="status-item success">
✔ Verified delivery route
</div>



<div className="status-item success">
✔ Customer protection
</div>



</div>





</div>









{arrived && (

<div className="dashboard-card rating-card">


<h2>
⭐ Rate Your Delivery
</h2>


<p>
Your feedback improves our service.
</p>





<div className="star-rating">


{[1,2,3,4,5].map((star)=>(


<span

key={star}

className={
star <= rating
?
"star active"
:
"star"
}

onClick={()=>setRating(star)}

>

★

</span>


))}


</div>






<textarea

className="review-box"

placeholder="Write your experience..."

value={review}

onChange={(e)=>setReview(e.target.value)}

/>






<button

className="submit-review-btn"

onClick={submitRating}

>

Submit Review

</button>


</div>


)}









<div className="quick-action">


<button

className="book-btn"

onClick={()=>navigate("/dashboard")}

>

⬅ Back Dashboard

</button>


</div>




</div>


</div>
);
}
